/** Remove origin-local download copies on an account change, never recordings. */
export async function clearLegacyDownloads(): Promise<void> {
  for (const [name, stores] of [
    ["pw-native-offline-packs", ["journeys"]],
    ["pw-companion-mountain-maps", ["maps"]],
  ] as const) {
    const db = await new Promise<IDBDatabase | null>((resolve, reject) => {
      let absent = false, blocked = false;
      const request = indexedDB.open(name);
      request.onupgradeneeded = event => { if (event.oldVersion === 0) { absent = true; request.transaction?.abort(); } };
      request.onsuccess = () => { if (blocked) { request.result.close(); return; } resolve(request.result); };
      request.onerror = () => absent ? resolve(null) : reject(request.error);
      request.onblocked = () => { blocked = true; reject(new Error("Close other PeakWave tabs and retry account cleanup.")); };
    });
    if (!db) continue;
    try {
      const present = stores.filter(store => db.objectStoreNames.contains(store));
      if (present.length) await new Promise<void>((resolve, reject) => {
        const tx = db.transaction(present, "readwrite");
        for (const name of present) tx.objectStore(name).clear();
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
        tx.onabort = () => reject(tx.error);
      });
    } finally { db.close(); }
  }
  localStorage.removeItem("peakwave:saved-session-window:v1");
  window.dispatchEvent(new Event("peakwave-session-window-saved"));
}
